export const statusLabelMap = {
	needsHelp: 'Needs Help',
	onTrack: 'On Track',
	parentMisalign: 'Parent Misalign',
	starred: 'Starred',
	recentlyActive: 'Recently Active',
}
